<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleUser } from '@fortawesome/pro-light-svg-icons'

const schoolSelector = useSchoolSelector()
const { user } = useAuthStore()
</script>

<template>
  <div class="user-overview">
    <CommonTypography>
      <FontAwesomeIcon :icon="faCircleUser" />
      {{ user?.fullName }}
    </CommonTypography>

    <CommonTypography style="margin-left: 34px;">
      {{ schoolSelector.currentActiveOrganization?.name }}
    </CommonTypography>

    <AppSettingsSchoolSelector />
  </div>
</template>

<style lang="scss" scoped>
  .user-overview {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .typography {
    font-size: 1.125rem;
    font-weight: 500;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  svg {
    width: 22px;
    height: 22px;
  }
</style>
